export const TECH = Object.freeze({
    FLUTTER: {
        name: "Flutter", 
        mainColor: "#18BDFD",
        textColor: "#FFF",
    },
    REACT: {
        name: "React",
        mainColor: "#61DAFB",
        textColor: "#FFF",
    },
    TAILWIND: {
        name: "Tailwind", 
        mainColor: "#38BDF9",
        textColor: "#FFF",
    },
    BOOTSTRAP: {
        name: "Bootstrap",
        mainColor: "#8711FC",
        textColor: "#FFF",
    },
    HTML: {
        name: "HTML",
        mainColor: "#E35026",
        textColor: "#FFF",
    },
    CSS: {
        name: "CSS",
        mainColor: "#214CE5",
        textColor: "#FFF",
    },
    JAVASCRIPT: {
        name: "JavaScript",
        mainColor: "#E9CA33",
        textColor: "#FFF",
    },
    DART: {
        name: "Dart",
        mainColor: "#235997",
        textColor: "#FFF",
    },
    PYTHON: {
        name: "Python",
        mainColor: "#3670A0",
        textColor: "#FFF",
    },
    NEXTJS: {
        name: "NextJS",
        mainColor: "#000000",
        textColor: "#FFF",
    },
    MONGODB: {
        name: "MongoDB",
        mainColor: "#6DAC48",
        textColor: "#FFF",
    },
    FIREBASE: {
        name: "Firebase",
        mainColor: "#F57F16",
        textColor: "#FFF",
    },
    FIGMA: {
        name: "Figma",
        mainColor: "#30323A",
        textColor: "#FFF",
    },
    GIT: {
        name: "Git",
        mainColor: "#F05033",
        textColor: "#FFF",
    },
    PREMIERE: {
        name: "Premiere",
        mainColor: "#2C073D",
        textColor: "#FFF",
    },
});
